import ThreeDModelView from "../components/modelviewer/ThreeDModelView";

const ThreeDModel = () => {
  return (
    <>
      <ThreeDModelView />
    </>
  );
};

export default ThreeDModel;
